import axios from 'axios';
import {
  TActivityArea,
  TBodyOptions,
  TFilterOptions,
  TProjectInfo,
  TSearchShelfCards,
  TVideoGame,
  TYarikanoGirl,
} from 'types';

const getSearchFilter = async (): Promise<TBodyOptions> => {
  const res = await axios.get('public/female-tags').then(function (response) {
    return response.data;
  });

  return res;
};

const getActivityAreas = async (): Promise<TActivityArea[]> => {
  return await axios.get(`public/activity-area`).then(function (response) {
    return response.data;
  });
};

const getFilterOptions = async (): Promise<TFilterOptions> => {
  return await axios.get(`public/filter-options`).then(function (response) {
    return response.data;
  });
};

const getProjectInformation = async (): Promise<TProjectInfo> => {
  const res = await axios
    .get('public/project-information')
    .then(function (response) {
      return response.data;
    });

  return res;
};

const getGameList = async (): Promise<TVideoGame[]> => {
  const res = await axios.get('public/games').then(function (response) {
    return response.data;
  });

  return res;
};

const findUserByUuid = async (uuid: string): Promise<{ nickname: string }> => {
  const res = await axios
    .get('public/male', { params: { uuid } })
    .then(function (response) {
      return response.data;
    });

  return res;
};

const getChatAdminUuidList = async (): Promise<{ data: string[] }> => {
  const res = await axios.get('public/admin-list').then(function (response) {
    return response.data;
  });

  return res;
};

const getSearchShelfCards = async (): Promise<TSearchShelfCards> => {
  const res = await axios.get('public/search-shelf-cards').then((response) => {
    return response.data;
  });

  return res;
};

const getYarikanoGirlsPublic = async (): Promise<TYarikanoGirl[]> => {
  const res = await axios.get('yarikano-girls/public').then((response) => {
    return response.data;
  });

  return res;
};

export {
  getSearchFilter,
  getActivityAreas,
  getProjectInformation,
  getFilterOptions,
  getGameList,
  findUserByUuid,
  getChatAdminUuidList,
  getSearchShelfCards,
  getYarikanoGirlsPublic,
};
